import React, { useState, useEffect } from "react";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import InputLabel from "@mui/material/InputLabel";
import Checkbox from "@mui/material/Checkbox";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Button from "@mui/material/Button";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import AddCircleSharpIcon from "@mui/icons-material/AddCircleSharp";
import RemoveCircleSharpIcon from "@mui/icons-material/RemoveCircleSharp";
import Styles from "../../../../../Slices/Mof/Styles.json";

function MaritalStatusOtherInfo( {
    object,
    wifeOrHusbandName,
    setWifeOrHusbandName,
    wifeOrHusbandCarrier,
    setWifeOrHusbandCarrier,
    wifeOrHusbandBranch,
    setWifeOrHusbandBranch,
    wifeOrHusbandFolderNumber,
    setWifeOrHusbandFolderNumber,
    checkAccessPrivileges,
}) {
  

    return (
        <>
            {/*###==> marital status other info  here ...  */}
            <h4
                style={{
                    marginRight: "10px",
                    color: "#5f7b8a",
                }}
            >
                معلومات الزوجة / الزوج
            </h4>
            <div
                style={{
                    display: "flex",
                    flexDirection: "row",
                    flexFlow: "row wrap",

                    border: "1px solid",
                    borderColor: "#5f7b8a",
                    borderRadius: 10,
                    margin: 10,
                    paddingBottom: 10,
                }}
            >
                <div
                    style={{
                        display: "flex",
                        width:'100%',
                        minWidth: 200,
                        marginTop: 10,
                        paddingTop: 10,
                        paddingLeft: 10,
                        paddingRight: 10,
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    <FormControl fullWidth>
                        <TextField
                            label="الاسم الكامل"
                            variant="outlined"
                            InputProps={{
                                readOnly: checkAccessPrivileges(),
                            }}
                            value={wifeOrHusbandName}
                            onChange={(e) => {
                                setWifeOrHusbandName(e.target.value);
                            }}
                        />
                    </FormControl>
                    <Typography className="fontForError">
                        {/* {messageErrors.length > 0
                      ? messageErrors.map((err) => {
                          if (err.wifeOrHusbandName) {
                            return err.wifeOrHusbandName;
                          }
                        })
                      : null} */}
                    </Typography>
                </div>


                <div
                    style={{
                        display: "flex",
                        width:'100%',
                        minWidth: 200,
                        marginTop: 10,
                        paddingTop: 10,
                        paddingLeft: 10,
                        paddingRight: 10,
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    <FormControl fullWidth>
                        <TextField
                            label="المهنة"
                            InputProps={{
                                readOnly: checkAccessPrivileges(),
                            }}
                            variant="outlined"
                            value={wifeOrHusbandCarrier}
                            onChange={(e) => {
                                setWifeOrHusbandCarrier(e.target.value);
                            }}
                        />
                    </FormControl>
                    <Typography className="fontForError">
                        {/* {messageErrors.length > 0
                      ? messageErrors.map((err) => {
                          if (err.wifeOrHusbandCareer) {
                            return err.wifeOrHusbandCareer;
                          }
                        })
                      : null} */}
                    </Typography>
                </div>

                <div
                    style={{
                        display: "flex",
                        width:'100%',
                        minWidth: 200,
                        marginTop: 10,
                        paddingTop: 10,
                        paddingLeft: 10,
                        paddingRight: 10,
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    <FormControl fullWidth>
                        <TextField
                            label="رقم الاضبارة"
                            InputProps={{
                                readOnly: checkAccessPrivileges(),
                            }}
                            variant="outlined"
                            value={wifeOrHusbandFolderNumber}
                            onChange={(e) => {
                                setWifeOrHusbandFolderNumber(e.target.value);
                            }}
                        />
                    </FormControl>
                    <Typography className="fontForError">
                        {/* {messageErrors.length > 0
                      ? messageErrors.map((err) => {
                          if (err.wifeOrHusbandFolderNumber) {
                            return err.wifeOrHusbandFolderNumber;
                          }
                        })
                      : null} */}
                    </Typography>
                </div>

                <div
                    style={{
                        display: "flex",
                        width:'100%',
                        minWidth: 200,
                        marginTop: 10,
                        paddingTop: 10,
                        paddingLeft: 10,
                        paddingRight: 10,
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    <FormControl fullWidth>
                        <TextField
                            label="الفرع"
                            variant="outlined"
                            InputProps={{
                                readOnly: checkAccessPrivileges(),
                            }}
                            value={wifeOrHusbandBranch}
                            onChange={(e) => {
                                setWifeOrHusbandBranch(e.target.value);
                            }}
                        />
                    </FormControl>
                    <Typography className="fontForError">
                        {/* {messageErrors.length > 0
                      ? messageErrors.map((err) => {
                          if (err.wifeOrHusbandBranch) {
                            return err.wifeOrHusbandBranch;
                          }
                        })
                      : null} */}
                    </Typography>
                </div>
            </div>

        </>
    )
}

export default MaritalStatusOtherInfo